import { AbstractSigner } from 'ethers';
import rpc from './adaptive.js';
const { waitForReceipt } = rpc;
const pending=new Map();
function readPending(key){try{return pending.get(key)||localStorage.getItem(key);}catch{return pending.get(key);}}
function remember(key,hash){pending.set(key,hash);try{localStorage.setItem(key,hash);}catch{/* memory still prevents repeat in this session */}}
function clear(key){pending.delete(key);try{localStorage.removeItem(key);}catch{}}
// The extension remains responsible for permission, signing and broadcasting.
export function createReadSigner(walletSigner,provider){
 return new class extends AbstractSigner {
  constructor(){super(provider);}
  getAddress(){return walletSigner.getAddress();}
  connect(){throw new Error('Signer connection is fixed');}
  signTransaction(tx){return walletSigner.signTransaction(tx);}
  signMessage(message){return walletSigner.signMessage(message);}
  signTypedData(...args){return walletSigner.signTypedData(...args);}
  async sendTransaction(tx){
   if((await walletSigner.provider.getNetwork()).chainId!==10n)throw new Error('Wrong network. Switch to Optimism first.');
   const address=await this.getAddress();const key='startax.pending.10.'+address.toLowerCase();
   const existing=readPending(key);
   if(existing){
    let receipt;try{receipt=await provider.getTransactionReceipt(existing);}catch{}
    if(!receipt)throw Object.assign(new Error('Transaction confirmation pending. Check your wallet before another swap.'),{code:'TRANSACTION_PENDING'});
    clear(key);
   }
   const response=await walletSigner.sendTransaction(tx);remember(key,response.hash);
   response.wait=async(confirms=1,timeoutMs=120000)=>{
    try{const receipt=await waitForReceipt(provider,response.hash,{confirms,timeoutMs});clear(key);return receipt;}
    catch(error){if(error.receipt)clear(key);throw error;}
   };
   return response;
  }
 }();
}
